const e = "0.5rem", a = "#0C2A4DCC", n = "0.25rem", c = "0.5rem", o = "1rem", s = "1.5rem", t = "320px", r = "640px", m = "960px", p = "1280px", S = "0.5rem";
export {
  a,
  s as b,
  n as c,
  r as d,
  c as e,
  S as f,
  e as g,
  o as h,
  m as i,
  p as j,
  t as k
};
